<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <Carousel
          :startAutoPlay="true"
          :timeout="5000"
          class="carousel"
          v-slot="{ currentSlide }">
        <Slide v-for="(slide, index) in carouselSlides" :key="index">
          <div v-show="currentSlide === index + 1" class="slide-info">
            <img :src="require(`../assets/img/bg/${slide}.jpg`)" alt=""/>
          </div>
        </Slide>
      </Carousel>
      <section class="pb-20 bg-gray-200 -mt-24">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap">
            <div class="lg:pt-12 pt-6 w-full md:w-3/12 px-4 text-center">
              <div class="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg ">
                <div class="px-4 py-5 flex-auto">
                  <div
                      class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                    <i class="fas fa-award"></i>
                  </div>
                  <h6 class="text-xl font-semibold">NAAC Accredited</h6>
                  <p class="mt-2 mb-4 text-gray-600">
                  </p>
                </div>
              </div>
            </div>
            <div class="lg:pt-12 pt-6 w-full md:w-3/12 px-4 text-center">
              <div class="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg">
                <div class="px-4 py-5 flex-auto">
                  <div
                      class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-indigo-500">
                    <i class="fas fa-retweet"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Excellent Faculty</h6>
                  <p class="mt-2 mb-4 text-gray-600">
                  </p>
                </div>
              </div>
            </div>
            <div class="lg:pt-12 pt-6 w-full md:w-3/12 px-4 text-center">
              <div class="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg">
                <div class="px-4 py-5 flex-auto">
                  <div
                      class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-pink-400">
                    <i class="fas fa-hands-helping"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Placement Assistance</h6>
                  <p class="mt-2 mb-4 text-gray-600">
                  </p>
                </div>
              </div>
            </div>
            <div class="lg:pt-12 pt-6 w-full md:w-3/12 px-4 text-center">
              <div class="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg">
                <div class="px-4 py-5 flex-auto">
                  <div
                      class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-green-400"
                  >
                    <i class="fas fa-fingerprint"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Best Academics</h6>
                  <p class="mt-2 mb-4 text-gray-600">

                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center mt-10">
            <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
              <p class="font-serif text-gray-600">Welcome to </p>
              <h4 class="text-3xl mb-2 font-semibold leading-normal">
                SND College of Engineering & Research Centre, Babhulgaon, Yeola
              </h4>
              <p class="font-medium leading-relaxed mt-4 mb-4 text-gray-600 text-justify ">
                SND College of Engineering & Research was established in the year 2006 with the sole aim to impart
                quality Technical Education. It is approved by AICTE & affiliated to Savitribai Phule Pune University,
                Pune Maharashtra state.

              </p>

              <router-link to="/about" class="font-bold text-gray-800 mt-8">Read more <i
                  class="fas fa-angle-double-right align-middle"></i></router-link>
            </div>
            <div class="w-full md:w-7/12 px-4 mr-auto ml-auto">
              <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
                <div class="shadow-md">
                  <h4 class="text-3xl font-semibold w-full bg-pink-700 p-2 text-white text-center">Vision</h4>
                  <div class="w-full bg-white border-2 border-gray-50 p-4 text-gray-600 font-semibold">
                    <blockquote>
                      To create multifaceted engineers ready to serve the nation and the world.
                    </blockquote>

                  </div>
                </div>
                <div class="shadow-md mt-4">
                  <h4 class="text-3xl font-semibold w-full bg-pink-700 p-2 text-white text-center">Mission</h4>
                  <div class="w-full bg-white border-2 border-gray-50 px-2">
                    <ul class="list-reset text-black mb-8 p-4 text-gray-600 font-sans font-semibold">
                      <li class="flex items-center mb-3">
                        <div class="rounded-full border-2 bg-gray-600  p-1 mr-2 shadow-md">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                               fill="currentColor">
                            <path fill-rule="evenodd"
                                  d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                  clip-rule="evenodd"/>
                          </svg>
                        </div>
                        <p class="text-justify">
                          To use value based universal education of engineering and technology to develop the nation for
                          global competitiveness and bring harmony to mankind.
                        </p>
                      </li>
                      <!--                      <li class="flex items-center mb-3">
                                              <div class="rounded-full border-2 bg-gray-600 p-1 mr-2 shadow-md">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                                                     fill="currentColor">
                                                  <path fill-rule="evenodd"
                                                        d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                                        clip-rule="evenodd"/>
                                                </svg>
                                              </div>
                                              <p class="text-justify">
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab aliquid autem consequuntur cumque
                                                deleniti deserunt earum eius ex facilis, incidunt natus neque, nulla, perspiciatis provident
                                                quia ratione unde! Sunt, tenetur?
                                              </p>
                                            </li>-->
                    </ul>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="relative py-20 bg-hero-pattern bg-no-repeat bg-cover">
        <div class="container mx-auto px-4">
          <div class="items-center flex flex-wrap">
            <div class="w-full md:w-4/12 ml-auto mr-auto p-4">
              <marquee direction="up" behavior="scroll">
                <notice-card title="Title" text="text"></notice-card>
              </marquee>
            </div>
            <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
              <div class="md:pr-12">

              </div>
            </div>
          </div>
        </div>
      </section>

      <!--      <section class="pt-20 pb-20">
              <div class="container mx-auto px-4">
                <div class="flex flex-wrap justify-center text-center mb-24">
                  <div class="w-full lg:w-6/12 px-4">
                    <h2 class="text-4xl font-semibold">What Students say about us</h2>
                  </div>
                </div>
                <v-carousel :items-to-show="3.5" :autoplay="3000" :wrapAround="true" :transition="3000"
                            style="height: auto;">
                  <v-slide v-for="(testimonial,index) in 10" :key="index">
                    <testimonial-card></testimonial-card>
                  </v-slide>
                </v-carousel>
              </div>
            </section>-->

      <key-recruiters></key-recruiters>

    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "../components/Navbar.vue";
import FooterComponent from "../components/Footer.vue";
import Carousel from "../components/Carousel.vue";
import Slide from "../components/Slide.vue";
import NoticeCard from "@/components/NoticeCard";
//import TestimonialCard from "../components/TestimonialCard";
import 'vue3-carousel/dist/carousel.css';
//import {Carousel as VCarousel, Slide as VSlide} from 'vue3-carousel';
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    FooterComponent,
    Carousel,
    Slide,
    NoticeCard,
    //TestimonialCard,
    KeyRecruiters,
    //VCarousel,
    //VSlide,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3","bg-4"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped>
.carousel {
  position: relative;
  max-height: 70vh;
  height: 70vh;

  .slide-info {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 100%;
    height: 100%;

    img {
      min-width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
